import React, { useRef, useEffect, useState } from 'react';
import whatsappIcon from '../assets/whatsapp.png'; // Asegúrate de tener el ícono de WhatsApp en esta ubicación
import logo from '../assets/logo.png'; // Asegúrate de que la ruta del logo sea correcta
import CountUp from 'react-countup';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import { Link, useNavigate } from 'react-router-dom';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faOilWell } from '@fortawesome/free-solid-svg-icons';
import { faRulerCombined } from '@fortawesome/free-solid-svg-icons';
import { faTint, faSyncAlt } from '@fortawesome/free-solid-svg-icons';

import { faWaterLadder, faTools } from '@fortawesome/free-solid-svg-icons'; // Importación de los íconos


import indaraLogo from '../assets/indara.png';
import indacorLogo from '../assets/indacor-logo.png';
import adecoagroLogo from '../assets/adecoagro-logo.png';
import agdLogo from '../assets/agd.png';
import arcorLogo from '../assets/arcor-logo.png';
import frutosLogo from '../assets/frutosdelsol.png';
import intaLogo from '../assets/inta.png';
import miruLogo from '../assets/miru.png';
import pepsiLogo from '../assets/pepsi.png';
import quilmesLogo from '../assets/quilmes.png';
import syngentaLogo from '../assets/syngenta.png';
import gustoLogo from '../assets/gusto-cuyo.png';

import pozodeagua from '../assets/pozo-agua.png';




import pais from '../assets/pais.png'
import { motion } from 'framer-motion';




function LandingPage() {
    const [startCount, setStartCount] = useState(false);
    const refMetrica = useRef(null);
    const videoRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        // Initialize animations with better performance options
        AOS.init({
            duration: 1200,
            once: true,
            disable: 'mobile',
            easing: 'ease-out-cubic'
        });

        // Optimize video loading
        if (videoRef.current) {
            videoRef.current.load();
        }

        // Improved intersection observer with better thresholds
        const observer = new IntersectionObserver(
            ([entry]) => {
                setStartCount(entry.isIntersecting);
            },
            {
                root: null,
                rootMargin: '0px',
                threshold: 0.2,
            }
        );

        if (refMetrica.current) {
            observer.observe(refMetrica.current);
        }

        return () => {
            if (refMetrica.current) {
                observer.unobserve(refMetrica.current);
            }
        };
    }, []);

    return (
        <div className="font-sans">
            {/* Hero Section with improved layout */}
            <div className="relative h-screen w-full bg-gradient-to-r from-blue-900 to-blue-600 text-white flex items-center justify-center overflow-hidden">
                {/* Background video with overlay */}
                <div className="absolute inset-0 w-full h-full">
                    <div className="absolute inset-0 bg-blue-900 bg-opacity-40 z-10"></div>
                    <video
                        ref={videoRef}
                        autoPlay
                        muted
                        loop
                        playsInline
                        className="w-full h-full object-cover"
                    >
                        <source src="/assets/video_ang.mp4" type="video/mp4" />
                        <source src="/assets/video_ang.webm" type="video/webm" />
                        Your browser does not support the video tag.
                    </video>
                </div>

                {/* Main content with improved typography and spacing */}
                <div className="relative z-20 text-center container mx-auto px-4 max-w-4xl">
                    <motion.div
                        className="flex flex-col items-center gap-8"
                        initial={{ opacity: 0, y: -30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                    >
                        <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold tracking-tight leading-tight text-white drop-shadow-lg" data-aos="fade-down">
                            EXPERIENCIA DESDE 1943 EN PERFORACIONES
                        </h1>

                        <p className="mt-4 text-lg md:text-xl text-blue-100 max-w-2xl" data-aos="fade-up" data-aos-delay="200">
                            Somos expertos en servicios de perforación con la mejor tecnología y equipo profesional para garantizar resultados de alta calidad.
                        </p>

                        <motion.div
                            className="mt-8 flex flex-col sm:flex-row gap-4 justify-center"
                            initial={{ opacity: 0, scale: 0.9 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.6, delay: 0.4 }}
                        >
                            <a
                                href="#contacto"
                                className="px-8 py-4 bg-gradient-to-r from-blue-500 to-blue-400 text-white text-lg font-medium rounded-lg hover:from-blue-600 hover:to-blue-500 transition duration-300 ease-in-out shadow-lg transform hover:scale-105"
                            >
                                CONTÁCTANOS
                            </a>
                        </motion.div>
                    </motion.div>
                </div>
            </div>

            {/* Sección de Video y Métricas */}
            <section
                id="metrica"
                ref={refMetrica}
                className="py-20 bg-gradient-to-b from-gray-100 to-white text-center w-full overflow-hidden"
                data-aos="fade-up"
            >
                <div className="container mx-auto px-4">
                    <h2 className="text-3xl md:text-4xl font-bold text-blue-700 mb-12 relative inline-block" data-aos="fade-down">
                        SOLUCIONES HÍDRICAS PARA AGRO E INDUSTRIA
                        <span className="absolute bottom-0 left-0 w-full h-1 bg-blue-500 transform scale-x-0 transition-transform duration-500 group-hover:scale-x-100"></span>
                    </h2>

                    <div className="flex flex-col md:flex-row justify-between items-center gap-8 lg:gap-12">
                        {/* Contenedor del Video con mejoras */}
                        <div className="w-full md:w-1/2 p-4" data-aos="fade-right" data-aos-delay="200">
                            <div className="relative rounded-xl overflow-hidden shadow-2xl transform transition-transform duration-300 hover:scale-105">
                                <div className="absolute inset-0 bg-blue-900 bg-opacity-20 z-10"></div>
                                <video
                                    src="/assets/video_2.mp4"
                                    width="100%"
                                    height="350"
                                    autoPlay
                                    muted
                                    loop
                                    playsInline
                                    className="w-full h-full object-cover"
                                ></video>
                                <div className="absolute bottom-4 left-4 z-20 bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-medium">
                                    Nuestra Experiencia en Acción
                                </div>
                            </div>
                        </div>

                        {/* Contenedor de Métricas con mejoras */}
                        <div className="w-full md:w-1/2 p-4" data-aos="fade-left" data-aos-delay="300">
                            <div className="bg-white rounded-xl shadow-lg p-8 border-t-4 border-blue-600">
                                <p className="text-lg text-gray-700 mb-8">
                                    Con más de 80 años de experiencia, ofrecemos soluciones hídricas integrales adaptadas a cada necesidad, garantizando calidad y eficiencia.
                                </p>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                    {/* Primer Métrica */}
                                    <div
                                        className="flex flex-col items-center p-6 bg-blue-50 rounded-lg transform transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
                                        data-aos="zoom-in"
                                        data-aos-delay="400"
                                    >
                                        <div className="bg-blue-100 p-4 rounded-full mb-4">
                                            <FontAwesomeIcon icon={faOilWell} className="h-14 w-14 text-blue-600" />
                                        </div>
                                        <h3 className="text-5xl font-extrabold text-blue-800 mb-2 flex items-center">
                                            {startCount && <CountUp end={2000} duration={2.5} separator="." />}
                                            <span className="text-blue-500 ml-1">+</span>
                                        </h3>
                                        <p className="text-lg font-medium text-gray-700">Pozos Realizados</p>
                                    </div>

                                    {/* Segunda Métrica */}
                                    <div
                                        className="flex flex-col items-center p-6 bg-blue-50 rounded-lg transform transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
                                        data-aos="zoom-in"
                                        data-aos-delay="500"
                                    >
                                        <div className="bg-blue-100 p-4 rounded-full mb-4">
                                            <FontAwesomeIcon icon={faRulerCombined} className="h-14 w-14 text-blue-600" />
                                        </div>
                                        <h3 className="text-5xl font-extrabold text-blue-800 mb-2 flex items-center">
                                            {startCount && <CountUp end={500000} duration={3} separator="." />}
                                            <span className="text-blue-500 ml-1">+</span>
                                        </h3>
                                        <p className="text-lg font-medium text-gray-700">Metros Entubados</p>
                                    </div>
                                </div>

                                <div className="mt-10">
                                    <a
                                        href="#proyectos"
                                        className="inline-flex items-center px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors duration-300 shadow-md"
                                    >
                                        VER PROYECTOS REALIZADOS
                                        <svg className="w-5 h-5 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/*
            <section
                id="nueva-seccion"
                className="py-24 flex flex-col justify-center items-center bg-gradient-to-r from-blue-100 via-white to-blue-100 text-center w-full shadow-md overflow-x-hidden"
            >
                <div className="w-full px-4">
                    <motion.h2
                        className="text-3xl md:text-4xl font-semibold text-blue-600 mb-8"
                        initial={{ opacity: 0, y: -50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1 }}
                    >
                        EXPERTOS EN PERFORACIÓN DE POZOS
                    </motion.h2>

                    <div className="flex flex-col md:flex-row justify-around items-center mb-8">
                        {/* Primer Servicio 
                        <motion.div
                            className="flex flex-col items-center mb-8 md:mb-0"
                            initial={{ opacity: 0, scale: 0.8 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 1, delay: 0.3 }}
                        >
                            <FontAwesomeIcon icon={faWaterLadder} className="h-20 mb-4 text-blue-600" />
                            <h3 className="text-2xl font-extrabold text-gray-900 mb-2">Pozos de Agua</h3>
                            <p className="text-lg text-gray-600 px-6 md:px-0">
                                IMPLEMENTAMOS EL METODO ROTATIVO PARA LA CAPTACION DE AGUA SUBTERRANEA, UTILIZANDO 4 MÁQUINAS Y MANTENIENDO UN TRABAJO ININTERRUMPIDO HASTA COMPLETAR EL PROYECTO

                            </p>
                        </motion.div>

                        {/* Segundo Servicio 
                        <motion.div
                            className="flex flex-col items-center"
                            initial={{ opacity: 0, scale: 0.8 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 1, delay: 0.5 }}
                        >
                            <FontAwesomeIcon icon={faTools} className="h-20 mb-4 text-blue-600" />
                            <h3 className="text-2xl font-extrabold text-gray-900 mb-2">Mantenimiento</h3>
                            <p className="text-lg text-gray-600 px-6 md:px-0">
                                SERVICIOS DE MANTENIMIENTO DE POZOS CON EQUIPAMIENTO DE ÚLTIMA TECNOLOGÍA.
                            </p>
                        </motion.div>
                    </div>

                    {/* Video Agregado 
                    <motion.div
                        className="w-full md:w-3/4 lg:w-2/3 mx-auto"
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, delay: 0.7 }}
                    >
                        <video
                            loop
                            autoPlay
                            muted
                            playsInline
                            className="w-full rounded-lg shadow-lg"
                        >
                            <source src="/assets/video_2.mp4" type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </motion.div>
                    
                </div>
            </section>
            */}


            {/* Sección de Actividades 
            <section className="bg-white py-24">
                <div className="container mx-auto px-4">
                    <div className="text-center mb-16">
                        <h2 className="text-5xl font-bold text-gray-900 mb-4">Nuestras Actividades</h2>
                        <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                            Descubre las actividades clave que realizamos para garantizar el éxito de nuestros proyectos de perforación y acondicionamiento de pozos.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                        {/* Tarjeta de Actividad 1 
                        <motion.div
                            className="relative bg-gradient-to-r from-blue-600 to-blue-500 text-white p-8 rounded-lg shadow-lg overflow-hidden"
                            whileHover={{ scale: 1.05 }}
                            transition={{ duration: 0.3 }}
                        >
                            {/* Icono decorativo 
                            <div className="absolute top-0 right-0 m-6 text-blue-300 opacity-20">
                                <FontAwesomeIcon icon={faTint} className="text-9xl" />
                            </div>
                            <div className="relative z-10">
                                <FontAwesomeIcon icon={faTint} className="text-5xl mb-4" />
                                <h3 className="text-3xl font-bold mb-2">Limpieza del Pozo</h3>
                                <p className="text-lg text-white opacity-90 leading-relaxed">
                                    Una vez aprobado el perfilaje eléctrico, se genera el diseño de intubación y se procede a la preparación de cañería y filtros.
                                </p>
                            </div>
                        </motion.div>

                        {/* Tarjeta de Actividad 2 
                        <motion.div
                            className="relative bg-gradient-to-r from-green-600 to-green-500 text-white p-8 rounded-lg shadow-lg overflow-hidden"
                            whileHover={{ scale: 1.05 }}
                            transition={{ duration: 0.3 }}
                        >
                            {/* Icono decorativo *
                            <div className="absolute top-0 right-0 m-6 text-green-300 opacity-20">
                                <FontAwesomeIcon icon={faSyncAlt} className="text-9xl" />
                            </div>
                            <div className="relative z-10">
                                <FontAwesomeIcon icon={faSyncAlt} className="text-5xl mb-4" />
                                <h3 className="text-3xl font-bold mb-2">Acondicionamiento del Pozo</h3>
                                <p className="text-lg text-white opacity-90 leading-relaxed">
                                    Luego de ser entubada y engravada o cementada la perforación, se procede con la limpieza y aforo de la misma.
                                </p>
                            </div>
                        </motion.div>
                    </div>
                </div>
            </section>
            */}

            {/* Sección de Desarrollo de Bombeo */}
            {/* Sección de Desarrollo de Bombeo */}
            <section id="desarrollo-de-bombeo" className="py-24 flex items-center bg-white w-full shadow-md overflow-x-hidden">
                <div className="w-full flex flex-col md:flex-row items-center justify-between px-4">
                    {/* Contenedor del Texto */}
                    <motion.div
                        className="md:w-1/2 md:pl-16 flex flex-col justify-center"
                        data-aos="fade-right"
                        initial={{ opacity: 0, x: -100 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1 }}
                    >

                        {/* Integración del Bloque de Pozos de Agua */}
                        <div className="flex flex-col md:flex-row justify-around items-center mb-8">
                            {/* Primer Servicio: Pozos de Agua */}
                            <motion.div
                                className="flex flex-col items-center mb-8 md:mb-0"
                                initial={{ opacity: 0, scale: 0.8 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 1, delay: 0.3 }}
                            >
                                {/* Reemplazar el ícono por la imagen del pozo de agua */}
                                <img
                                    src={pozodeagua}
                                    alt="Ícono de Pozo de Agua"
                                    className="h-20 mb-4"
                                />
                                <h3 className="text-2xl font-extrabold text-gray-900 mb-2">PERFORACIONES</h3>
                                <p className="text-lg text-gray-600 px-6 md:px-0">
                                    Implementamos el método rotativo para la captación de agua subterránea,utilizando 4 máquinas y manteniendo un trabajo ininterrumpido hasta completar el proyecto.
                                </p>
                            </motion.div>
                        </div>
                    </motion.div>

                    {/* Contenedor del Mapa */}
                    <motion.div
                        className="md:w-1/2 h-full p-6 flex items-center justify-center"
                        data-aos="fade-left"
                        initial={{ opacity: 0, x: 100 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1 }}
                    >
                        {/* Reducir el tamaño del mapa */}
                        <div className="relative w-full max-w-xs h-auto overflow-hidden">
                            <img
                                src={pais}
                                alt="Mapa de Argentina"
                                className="w-full h-auto object-contain shadow-lg"
                            />
                        </div>
                    </motion.div>
                </div>
            </section>


            {/* Sección de Clientes */}
            <section
                id="clientes"
                className="py-16 bg-gradient-to-b from-gray-100 to-gray-200 flex flex-col justify-center items-center w-full overflow-x-hidden"
            >
                <div className="w-full text-center px-4">
                    <h2 className="text-4xl font-bold text-gray-900 mb-6 tracking-tight">
                        Empresas que confían en nosotros
                    </h2>


                    <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6 items-center">
                        {/* Logos de Clientes */}
                        {[
                            { logo: indaraLogo, alt: "Cliente 1", delay: 100 },
                            { logo: indacorLogo, alt: "Cliente 2", delay: 200 },
                            { logo: adecoagroLogo, alt: "Cliente 3", delay: 300 },
                            { logo: arcorLogo, alt: "Cliente 4", delay: 400 },
                            { logo: frutosLogo, alt: "Cliente 5", delay: 500 },
                            { logo: intaLogo, alt: "Cliente 6", delay: 600 },
                            { logo: miruLogo, alt: "Cliente 7", delay: 700 },
                            { logo: pepsiLogo, alt: "Cliente 8", delay: 800 },
                            { logo: quilmesLogo, alt: "Cliente 9", delay: 900 },
                            { logo: syngentaLogo, alt: "Cliente 10", delay: 1000 },
                            { logo: agdLogo, alt: "Cliente 11", delay: 1100 },
                            { logo: gustoLogo, alt: "Cliente 12", delay: 1200 }

                        ].map(({ logo, alt, delay }) => (
                            <motion.div
                                className="flex justify-center items-center"
                                key={alt}
                                initial={{ opacity: 0, y: 30, scale: 0.9 }} // Añadimos una escala y traslación inicial
                                animate={{ opacity: 1, y: 0, scale: 1 }} // Animación hacia el estado final
                                transition={{ duration: 0.6, delay: delay / 1000, ease: "easeOut" }} // Suavizado en la animación
                                whileHover={{ scale: 1.1, rotate: 2 }} // Añadimos un pequeño giro en hover
                            >
                                <motion.img
                                    src={logo}
                                    alt={alt}
                                    className="max-h-16 md:max-h-20 opacity-80 hover:opacity-100 transition-opacity duration-300 ease-in-out"
                                />
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            <section
                id="quienes-somos"
                className="relative h-[60vh] w-full bg-cover bg-center bg-no-repeat flex items-center justify-center shadow-lg"
                style={{
                    backgroundImage: "url('/assets/historia.jpg')",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    backgroundAttachment: "fixed"  // Efecto Parallax: Fija la imagen mientras el contenido se desplaza
                }}
            >
                {/* Filtro de desenfoque y overlay más suave */}
                <div className="absolute top-0 left-0 w-full h-full bg-black opacity-50 backdrop-blur-sm"></div>

                <motion.div
                    className="relative z-10 text-center text-white"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: "easeOut" }}
                >
                    <div className="flex justify-center space-x-4">
                        {/* Botón con efecto hover más dinámico */}
                        <motion.button
                            onClick={() => navigate('/historia')}
                            className="px-8 py-4 bg-white text-black text-lg font-semibold rounded-md hover:bg-gray-200 hover:text-gray-800 transition duration-300 ease-in-out cursor-pointer"
                            whileHover={{ scale: 1.1, x: 5 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            NUESTRA HISTORIA
                        </motion.button>
                    </div>
                </motion.div>
            </section>

            {/* WhatsApp Floating Box */}
            <motion.div
                className="fixed bottom-4 right-4 z-50 flex items-center bg-gray-100 text-gray-800 rounded-full p-2 shadow-lg sm:bottom-8 sm:right-8"
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8, delay: 1 }}
            >
                <span className="hidden sm:inline mr-2">¿Tenés alguna duda?</span>
                <a
                    href={`https://wa.me/5492644802789?text=${encodeURIComponent('Hola! Quiero conocer más acerca de los servicios que brindan.')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img src={whatsappIcon} alt="WhatsApp" className="h-8 w-8 sm:h-10 sm:w-10" />
                </a>
            </motion.div>
        </div>
    );
}

export default LandingPage;